import React, { useState } from 'react';

import { Alert, AlertTitle, Tooltip } from '@mui/material';

import Button from '@/components/Buttons/Button';
import KeyDialog from '@/components/KeyDialog';
import Typography from '@/components/Typography';
import { Permission } from '@/entities/permissions';
import usePermission from '@/shared/hooks/usePermission';

const TokenLink = ({ bgcolor = 'background.paper' }: { bgcolor?: string }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { hasPermission } = usePermission();
  const isTokenGenerationBlocked = !hasPermission(Permission.GenerateApiToken);
  const premiumRequiredMessage = 'Premium access is required to generate API tokens.';

  return (
    <Alert
      severity='error'
      sx={{
        backgroundColor: bgcolor,
        color: 'text.primary',
        borderLeft: `4px solid`,
        borderColor: 'primary.main',
        py: 2,
        px: 1.5,

        '& .MuiAlert-icon': {
          color: 'primary.main',
          p: 0
        },
        '& .MuiAlert-message': {
          p: 0,
          gap: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }
      }}
    >
      <AlertTitle
        sx={{
          fontSize: '12px',
          m: 0,
          mt: 0.25
        }}
      >
        API access requires a token
      </AlertTitle>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500
        }}
      >
        Create your first token in Settings to get started with API exports.{' '}
        <Tooltip
          disableFocusListener={!isTokenGenerationBlocked}
          disableHoverListener={!isTokenGenerationBlocked}
          disableTouchListener={!isTokenGenerationBlocked}
          title={isTokenGenerationBlocked ? premiumRequiredMessage : ''}
        >
          <span style={{ display: 'inline-flex' }}>
            <Button
              disabled={isTokenGenerationBlocked}
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: 'primary.main',
                p: 0,
                ml: 0.25
              }}
              variant='text'
              onClick={() => {
                if (isTokenGenerationBlocked) {
                  return;
                }
                setDialogOpen(true);
              }}
            >
              Generate token
            </Button>
          </span>
        </Tooltip>
      </Typography>

      <KeyDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
      />
    </Alert>
  );
};

export default TokenLink;
